import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '电影', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '综艺', path: '/category/variety' },
    { label: '动漫', path: '/category/anime' },
    { label: '纪录片', path: '/category/documentary' },
    { label: '短视频', path: '/category/short' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '用户口碑', path: '/about#reputation' },
    { label: '常见问题', path: '/#faq' },
  ],
  热门资讯: [
    { label: '平台优势', path: '/article/why-bale-video-is-best-alternative' },
    { label: '追剧指南', path: '/article/summer-must-watch-chinese-dramas' },
    { label: '用户体验', path: '/article/user-experience-switching-to-bale-video' },
    { label: '技术揭秘', path: '/article/bale-video-tech-behind-4k-streaming' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-900 font-heading">芭乐视频</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              芭乐视频是新一代高清在线视频平台，为喜爱91视频、97视频的用户提供更好的观影选择。
              急速加载不缓冲，海量资源免费看。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 芭乐视频 BaleVideo. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}